/**
 * System-managed enums for Email Rules
 *
 * These enum definitions are created automatically on demand.
 * The enum itself is immutable (name/description cannot be changed),
 * but the OPTIONS within the enum are user-configurable via CRUD operations.
 */

export const EMAIL_RULES_SYSTEM_ENUMS = {
  EMAIL_RULE_EVENTS: {
    name: "Email Rule Events",
    description:
      "User-defined event types that can be triggered by inbound emails",
  },
} as const;

export type EmailRulesSystemEnumKey = keyof typeof EMAIL_RULES_SYSTEM_ENUMS;
